import React from 'react'
import './task.css'

const Task = ({ type, data }) => {
  
  return <div className='task-container'>{data.title}</div>
}

export default Task
